import type { YammerState } from '../../state/types';

type GetPersistKey = (state: YammerState) => string | undefined;
export const getPersistKey: GetPersistKey = (state) => state.persistConfig.key;
